/* ============================================================
   KaNi Candy - Menueschublade
   Der Schliessknopf sitzt im Kopfbereich an der Stelle des Warenkorbs und
   gehoert damit nicht zur Schublade selbst. Er kann sie deshalb nicht ueber
   das <details> schliessen, ohne an Dawns Mechanik vorbeizugreifen: die
   verwaltet Fokusfalle, Sperre des Seitenscrollens und die Klasse
   menu-open. Der Knopf loest stattdessen einen Klick auf die vorhandene
   Zusammenfassung aus - so laeuft alles weiter durch Dawns eigenen Weg.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-kani-menue-schliessen]');
    if (!knopf) return;

    var schublade = document.getElementById('Details-menu-drawer-container');
    if (!schublade || !schublade.hasAttribute('open')) return;

    var zusammenfassung = schublade.querySelector('summary');
    if (zusammenfassung) zusammenfassung.click();
  });
})();
